import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueMaterial from "vue-material";

import App from './App'
import Icon from 'vue2-svg-icon/Icon.vue'
import kayak from '@/frame/kayak.js'
import global from '@/frame/global';
import '@/frame/utils.js';

import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import axios from 'axios'




import "vue-material/dist/vue-material.min.css";
import $ from 'jquery'
import router from './router'


// import kayakPlugin from "@/frame/kayakPlugin.js"

import 'babel-polyfill'

import store from '@/store'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueQuillEditor);
Vue.use(ElementUI, {size: 'small'});
//Vue.use(kayakPlugin);
Vue.use(router);

Vue.use(VueMaterial);

let startApp = function () {
  axios.get('/static/config.json').then((res) => {
    // 基础地址
    Vue.prototype.BASE_URL = res.data.BASE_URL;
    localStorage.setItem("requestHeaher",res.data.BASE_URL)
  })
}
startApp()




Vue.config.productionTip = false;
Vue.component('icon', Icon);
Vue.prototype.global=global;
// const originalPush = router.prototype.push
// router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
router.beforeEach((to, from, next) => {
  store.commit("setCurrentRouter",to.path)
      next()
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js